import {Routes} from '@angular/router';
import {permissionGuard} from "./guards/permission.guard";

export const prefix = "dashboard"
export const routes: Routes = [
  {
    path: "",
    title: "Ravcredit",
    loadComponent: () => import("./landing/home/home.component").then(m => m.HomeComponent)
  },
  {
    title: "App Ravcredit",
    path: "ravcredit-app",
    loadComponent: () => import("./landing/mobile-app/mobile-app.component").then(m => m.MobileAppComponent)
  },
  {
    path: "dashboard",
    title: "Admin | Dashboard",
    canActivate: [permissionGuard],
    loadComponent: () => import("./components/dashboard/dashboard.component").then(m => m.DashboardComponent)
  },
  {
    path: "sign-in",
    title: "Inicio de sesión",
    loadComponent: () => import("./components/login/login.component").then(m => m.LoginComponent)
  },
  {
    path: "dashboard",
    title: "Admin | Dashboard",
    canActivate: [permissionGuard],
    loadComponent: () => import("./components/dashboard/dashboard.component").then(m => m.DashboardComponent)
  },
  {
    path: "notifications-panel",
    title: "Panel de notificaciones",
    canActivate: [permissionGuard],
    loadComponent: () => import("./components/notifications/notifications.component").then(m => m.NotificationsComponent)
  },
  {
    path: "search",
    canActivate: [permissionGuard],
    loadComponent: () => import("./components/search/search.component").then(m => m.SearchComponent)
  },
  {
    path: "business",
    title: "Ravcredit Info",
    canActivate: [permissionGuard],
    loadComponent: () => import("./components/business/business.component").then(m => m.BusinessComponent)
  },
  {
    path: "contract/create",
    title: "Admin | Crear Contrato",
    canActivate: [permissionGuard],
    loadComponent: () => import("./components/contract/contract.component").then(m => m.ContractComponent)
  },
  {
    path: "contract-detail/:id",
    title: "Detalles de Contrato",
    canActivate: [permissionGuard],
    loadComponent: () => import("./components/contract-detail/contract-detail.component").then(m => m.ContractDetailComponent)
  },
  {
    path: "contracts",
    title: "Admin | Contratos",
    canActivate: [permissionGuard],
    loadComponent: () => import("./components/contract-all/contract-all.component").then(m => m.ContractAllComponent)
  },
  {
    path: "user",
    title: "Admin | Usuarios",
    canActivate: [permissionGuard],
    loadComponent: () => import("./components/user/user.component").then(m => m.UserComponent)
  },
  {
    path: "save-contract/:id",
    title: "Ravcredit: Contrato",
    canActivate: [permissionGuard],
    loadComponent: () => import("./components/contract/pdf-contract/pdf-contract.component").then(m => m.PdfContractComponent)
  },
  {
    path: "reference/:id",
    title: "Referencia de pago",
    canActivate: [permissionGuard],
    loadComponent: () => import("./components/reference/reference.component").then(m => m.ReferenceComponent)
  },
  {
    path: "payments",
    title: "Ravcredit: Pagos",
    canActivate: [permissionGuard],
    loadComponent: () => import("./components/payments/payments.component").then(m => m.PaymentsComponent),
  },
  {
    title: "Ravcredit: Pago DynamiCore",
    path: "create-payment-dynamic/:id/:contract",
    canActivate: [permissionGuard],
    loadComponent: () => import("./components/new-payment-dynamic/new-payment-dynamic.component").then(m => m.NewPaymentDynamicComponent),
  },
  {
    title: "Ravcredit: Pago Conekta",
    path: "create-payment-conekta/:id/:contract",
    canActivate: [permissionGuard],
    loadComponent: () => import("./components/new-payment-conekta/new-payment-conekta.component").then(m => m.NewPaymentConektaComponent),
  },
  {
    title: "Ravcredit: Aviso de privacidad",
    path: "privacy-policy",
    canActivate: [permissionGuard],
    loadComponent: () => import("./components/privacy-policy-es/privacy-policy-es.component").then(m => m.PrivacyPolicyEsComponent),
  },
  {
    path: "privacy-policy-en",
    canActivate: [permissionGuard],
    loadComponent: () => import("./components/privacy-policy-en/privacy-policy-en.component").then(m => m.PrivacyPolicyEnComponent),
  },
  {
    path: "amortization/:id",
    title: "Tabla de amortización",
    canActivate: [permissionGuard],
    loadComponent: () => import("./components/amortization/amortization.component").then(m => m.AmortizationComponent)
  },
  {
    path: "**",
    redirectTo: "404"
  },
  {
    path: "404",
    loadComponent: () => import("./components/not-found/not-found.component").then(m => m.NotFoundComponent)
  },
];
